import React, { useEffect, useState } from "react";
// import rootStyle from "./RootStyle.module.css";
import appDetailStyle from "../Overview/AppDetail.module.css";

import { AdminSidebarMenu } from "../Sidebar/AdminSidebarMenu";
// import { FirstAppHeader } from "../../Header/FirstAppHeader";
import { useParams, useLocation } from "react-router-dom";
import ChatAdmin from "./ChatAdmin";
import Stats from "./Stats";
import useIsMobile from "./useIsMobile";
import CustNInstNDownloadClient from "./CustNInstNDownloadClient";

import { MobileHeader } from "../../Header/MobileHeader";
import Breadcrumbs from "../../Home/Breadcrumbs";
import Permissions from "./Permissions";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export const RootPage = () => {
  const isMobile = useIsMobile();
  console.log("what is it isMobile", isMobile);
  const location = useLocation();
  const [activeItemId, setActiveItemId] = useState("All User Chats");
  const { app_name } = useParams();
  const [appData, setAppData] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isMobileView, setIsMobileView] = useState(false);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkMobileView();
    window.addEventListener("resize", checkMobileView);
    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  const toggleSidebar = () => {
    console.log("you click on back btn");

    if (isMobileView) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const activeWindowRightComponent = (activeItemId, appData) => {
    console.log("whyare we", activeItemId);
    console.log("what is in the appData", appData);
    if (activeItemId === "Stats") {
      return <Stats appData={appData} />;
    } else if (activeItemId === "Permissions") {
      return <Permissions appData={appData} />;
    } else if (activeItemId === "All User Chats") {
      return <ChatAdmin appData={appData} />;
    } else {
      return <div>No condition matched</div>;
    }
  };

  return (
    <>
      <div className={appDetailStyle["sidebar-mainContainer"]}>
        <div
          className={`${appDetailStyle.sidebar} ${isSidebarOpen ? appDetailStyle.open : ""
            }`}
        >
          <AdminSidebarMenu
            toggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
            activeItemId={activeItemId}
            setActiveItemId={setActiveItemId}
            appData={appData}
          />
        </div>
        <div
          className={`${appDetailStyle.rootMainContant} ${isSidebarOpen ? appDetailStyle.hidden : ""
            }`}
        >
          {activeItemId && (
            <div style={{ height: "100%" }}>
              {activeWindowRightComponent(activeItemId, appData)}
            </div>
          )}
        </div>
      </div>

    </>
  );
};
